<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Custom Rules</h5>
          <!-- {{broadcastParam.broadcast_id}} -->
          <button ref="dismisModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- {{formParam}} -->
            <!-- {{formParam}}
            <hr />
            {{formParamCustomRules}}-->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Choose Text Reply:</label>
                    <!-- {{ selectedLicense }} -->
                    <div class="input-group m-b-30">
                      <multiselect :class="'form-control'" v-model="selectedLicense" id="ajax" label="button_text"
                        track-by="id"
                        :placeholder="(typeof (selectedLicense) != 'undefined' && typeof (selectedLicense.license_name) != 'undefined' ? selectedLicense.license_name : '')"
                        open-direction="bottom" :custom-label="customLabelLicense" :options="licenseOptions"
                        :multiple="true" :searchable="true" :loading="isLoadingLicense" :internal-search="false"
                        :close-on-select="false" :options-limit="300" :limit="3" :limit-text="limitText"
                        :max-height="600" :show-no-results="true" :hide-selected="true"
                        @search-change="asyncFindLicenseSelect" :show-labels="false">
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <span>{{ option.button_text }}</span>
                            <span class="custom__remove" @click="remove(option);">❌</span>
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div class="multiselect__clear"
                            v-if="typeof (selectedLicense.length) != 'undefined' && selectedLicense.length"
                            @mousedown.prevent.stop="clearAllLicense(props.search)"></div>
                        </template>
                        <span slot="noResult">Oops! No elements found.</span>
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-sm-8 col-md-8">
                          <div class="form-group">
                            <label>Respond Message:</label>
                            <!-- {{ button_response }} -->
                            <!-- {{broadcastParam}} -->
                            <div class="message-bar">
                              <div class="message-inner">
                                <div class="message-area">
                                  <div class="input-group m-b-30">
                                    <textarea :style="'height:185px'" ref="messagebox" class="form-control"
                                      v-model="button_response"></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 col-md-4">
                          <!-- {{formParam.detail_button}} -->
                          <div class="row" style="margin-top:30px;">
                            <div class="col-md-12">
                              <div class="form-group" v-show="false">
                                <div class="form-group form-focus select-focus">
                                  <select v-model="formParam.button_type" class="form-control"
                                    @change="resetDetailButton('text_reply')">
                                    <option :value="''">-- Select --</option>
                                    <option v-for="(row, idxBtn) in interactiveMessageType" :key="idxBtn"
                                      :value="row.id">{{ row.label
                                      }}
                                    </option>
                                  </select>
                                  <label class="focus-label">Button Type</label>
                                </div>
                              </div>
                              <!-- <div class="form-group">
                                <label>Button Type</label>
                                <div class="col-lg-9">
                                  <div class="form-check form-check-inline">
                                    <input
                                      @click="resetDetailButton('button')"
                                      class="form-check-input"
                                      type="radio"
                                      v-model="formParam.button_type"
                                      id="button"
                                      value="button"
                                    />
                                    <label class="form-check-label" for="button">Button</label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      @click="resetDetailButton('link')"
                                      v-model="formParam.button_type"
                                      class="form-check-input"
                                      type="radio"
                                      id="link"
                                      value="link"
                                    />
                                    <label class="form-check-label" for="link">
                                      Link/Call
                                      <i
                                        style="font-size:10px;"
                                        class="badge badge-danger"
                                      >beta</i>
                                    </label>
                                  </div>
                                </div>
                              </div>-->
                            </div>
                            <div class="col-md-12 px-0">
                              <template v-if="formParam.button_type == 'text_reply'">
                                <!-- <div v-for="index in defaultDetailTextReply" :key="index" class="col-md-12">
                                  <div class="form-group form-focus select-focus">
                                    <select v-model="formParam.detail_button[(index - 1)].auto_reply_button_id"
                                      class="form-control selectTextReply">
                                      <option :value="''">-- Select --</option>
                                      <option v-for="(row, idxBtn) in textReplyRows" :ref="'text_reply_' + row.id"
                                        :key="idxBtn" :value="row.id">{{ row.title }}</option>
                                    </select>
                                    <label class="focus-label">Text Reply {{ index }}</label>
                                  </div>
                                </div> -->
                                 <div class="col-12">
                                    <text-reply v-model="formParam"  :isShowForm="isShowForm" />
                                  </div>
                              </template>
                              <template v-if="formParam.button_type == 'list_text'">
                                <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                                  <div class="form-group form-focus select-focus">
                                    <select v-model="formParam.detail_button[(index - 1)].auto_reply_button_id"
                                      class="form-control">
                                      <option :value="''">-- Select --</option>
                                      <option v-for="(row, idxBtn) in buttonsRows" :key="idxBtn" :value="row.id">
                                        {{ row.button_text }}</option>
                                    </select>
                                    <label class="focus-label">List {{ index }}</label>
                                  </div>
                                </div>
                              </template>
                              <template v-if="formParam.button_type == 'button'">
                                <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                                  <div class="form-group form-focus select-focus" v-if="index <= 3">
                                    <select v-model="formParam.detail_button[(index - 1)].auto_reply_button_id"
                                      class="form-control">
                                      <option :value="''">-- Select --</option>
                                      <option v-for="(row, idxBtn) in buttonsRows" :key="idxBtn" :value="row.id">
                                        {{ row.button_text }}</option>
                                    </select>
                                    <label class="focus-label">Button {{ index }}</label>
                                  </div>
                                </div>
                              </template>
                              <template v-if="formParam.button_type == 'link'">
                                <div v-for="index in defaultDetailButton" :key="index" class="px-0 col-md-12">
                                  <div class="form-group form-focus select-focus" v-if="index <= 3">
                                    <select v-model="formParam.detail_button[(index - 1)].auto_reply_button_id"
                                      class="form-control">
                                      <option :value="''">-- Select --</option>
                                      <option v-for="(row, idxBtn) in linkRows" :key="idxBtn" :value="row.id">
                                        {{ row.button_text }}</option>
                                    </select>
                                    <label class="focus-label">Link/Call {{ index }}</label>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending == false">
                    <button @click.prevent="saveForm(0)" class="btn btn-md btn-success" type="button"
                      :style="'margin-left:10px;'">
                      <i class="fa fa-check"></i> Save
                    </button>
                    <button @click.prevent="saveForm(1)" class="btn btn-md btn-info" type="button">
                      <i class="fa fa-check"></i> Save &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import TextReply from '@/components/TextReply/index.vue';
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
    TextReply
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      interactiveMessageType: [
        // { id: "button", label: "Button" },
        // { id: "link", label: "Link/Call" },
        { id: "text_reply", label: "Text Reply" },

        // { id: "list_text", label: "List" }
      ],
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
          title: "",
        },
        page: 1,
        perPage: 500 // perPage
      },
      linkRows: [],
      button_response: "",
      buttonsLoading: false,
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
          title: "",

        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsRows: [],
      selectedLicense: [],
      licenseOptions: [],
      textReplyRows: [],
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500 // perPage
      },
      licenseListParam: {
        columnFilters: {
          id: "",
          button_title: "",
          button_text: "",
          button_response: "",
          title: "",
        },
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      isSending: false,
      defaultDetailTextReply: 10,
      defaultDetailButton: 10,
      formParam: {
        header_id: "",
        button_type: "text_reply",
        button_response: "",
        detail_button: [
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          },
          {
            header_id: "",
            button_type: "text_reply",
            auto_reply_button_id: ""
          }
        ]
      },
      isLoading: false
    };
  },
  watch: {
    selectedLicense: {
      handler: async function (val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        if (val.length > 1 && val != oldVal) {
          var that = this;
          setTimeout(async function () {
            // if (
            //   that.broadcastParam.broadcast_id != "" &&
            //   that.broadcastParam.broadcast_id != null
            // ) {
            let lengthOld = oldVal.length;
            val.splice(0, 1);
            that.selectedLicense = val;
            that.formParam.header_id = val[0].id;
            console.log("vaaaal", val[0]);

            that.buttonDetailData(that.formParam.header_id);
            await that.loadTextReply();
            // await that.loadReplyButtons();
            // await that.loadReplyLink();

            await that.removeButtonRows(that.formParam.header_id);
            console.log("that.formParam.header_id", that.formParam.header_id);
            return;
            // }
          }, 300);
        }

        // if (val != oldVal) {
        if (val.length == 1) {
          this.selectedLicense = val;
          this.formParam.header_id = val[0].id;
          this.buttonDetailData(this.formParam.header_id);
          await this.loadTextReply();
          // await this.loadReplyButtons();
          // await this.loadReplyLink();
          await this.removeButtonRows(this.formParam.header_id);

          // console.log("that.val", val);

          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedLicense = [];
          this.formParam.header_id = "";
          this.formParam.button_type = "text_reply";
          this.formParam.detail_button = [
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            },
            {
              header_id: "",
              button_type: "text_reply",
              auto_reply_button_id: ""
            }
          ];
          this.button_response = "";
          this.formParam.button_response = this.button_response;

          return;
        }
      },
      deep: true
    },
    isShowForm: {
      handler: function (val, oldVal) {
        console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          this.selectedLicense = [];
          this.textReplyRows = [];
          this.buttonsRows = [];
          this.linkRows = [];
          var that = this;
          // console.log("that.formParamSRSt",that.formParamSRSt)
          setTimeout(function () {
            console.log("timeout", that.formParamCustomRules.header_id);
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamCustomRules.header_id != "" &&
              that.formParamCustomRules.header_id != null
            ) {
              // console.log("that.formParamSRSt", that.formParamSRSt);
              that.formParam = that.formParamCustomRules;
              console.log("EDIIIT", that.formParam);
              if (that.formParam.header_id != "") {
                that.asyncFindLicense("", that.formParam.header_id);
              }

              if (
                that.formParam.detail_button.length < that.defaultDetailButton
              ) {
                let kekuranganBtn =
                  that.defaultDetailButton -
                  that.formParam.detail_button.length;
                for (var i = 0; i < kekuranganBtn; i++) {
                  that.formParam.detail_button.push({
                    button_type: "text_reply",
                    auto_reply_button_id: "",
                    header_id: ""
                  });
                }
              }

              that.loadTextReply();
              // that.loadReplyButtons();
              // that.loadReplyLink();
            } else {
              that.asyncFindLicense("", "");
              that.loadTextReply();
              // that.loadReplyLink();

              // that.loadReplyButtons();
              that.formParam = {
                header_id: "",
                button_type: "text_reply",
                button_response: '',
                detail_button: [
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  },
                  {
                    header_id: "",
                    button_type: "text_reply",
                    auto_reply_button_id: ""
                  }
                ]
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    formParamCustomRules() {
      return this.$store.state.automation.formParamCustomRules;
    },
    isShowForm() {
      return this.$store.state.automation.isShowForm;
    }
  },
  methods: {
    removeButtonRows(header_id) {
      if (this.buttonsRows != null) {
        var index = this.buttonsRows
          .map(x => {
            return x.id;
          })
          .indexOf(header_id);
        if (index >= 0) {
          this.buttonsRows.splice(index, 1);
        }
      }
    },
    async buttonDetailCustomRules(id) {
      this.formParam.header_id = await id;
      this.formParam.detail_button = await [
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        },
        {
          header_id: id,
          button_type: this.formParam.button_type,
          auto_reply_button_id: ""
        }
      ];
      await this.$store
        .dispatch("automation/detailCustomRules", id) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          console.log("dataaa", data);
          if (data.length) {
            this.formParam.detail_button = [];
            data.forEach((value, index) => {
              if (index == 0) {
                this.formParam.button_type = value.button_type;
                this.button_response = value.button_response
                // if(this.button_response)
              }
              let newData = {};
              newData = {
                header_id: value.header_id,
                button_type: value.button_type,
                auto_reply_button_id: value.auto_reply_button_id
              };
              console.log("newData", newData);

              this.formParam.detail_button.push(newData);
            });
          }
        });
      if (this.formParam.detail_button.length < this.defaultDetailButton) {
        let kekuranganBtn =
          (await this.defaultDetailButton) -
          this.formParam.detail_button.length;
        for (var i = 0; i < kekuranganBtn; i++) {
          await this.formParam.detail_button.push({
            header_id: id,
            button_type: this.formParam.button_type,
            auto_reply_button_id: ""
          });
        }
      }
      // console.log("this.formParam.detail_button", this.formParam.detail_button);
    },
    async buttonDetailData(id) {
      let dataParam = await {};
      dataParam = await {
        id: id
      };

      await this.$store
        // .dispatch("automation/detailReplyButtons", dataParam) // sesuai kan dengan method di API
        .dispatch("automation/detailTextReply", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          // console.log("dataaax",data)
          this.button_response = data.header.message;
        });
      await this.buttonDetailCustomRules(id);
    },
    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabelLicense({ button_title, button_text }) {
      if (typeof button_text != "undefined") {
        return `${button_text} (${button_title})`;
      }
    },
    asyncFindLicenseSelect(query) {
      // console.log("search")
      this.licenseOptions = [];
      // this.licenseListParam.columnFilters.button_text = query;
      this.licenseListParam.columnFilters.title = query;
      this.licenseListParam.columnFilters.id = "";
      this.$store
        .dispatch("automation/listTextReply", this.licenseListParam)
        .then(response => {
          // this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          // this.isLoadingLicense = false;
        });
    },
    asyncFindLicense(query, id) {
      this.licenseListParam.columnFilters.title = query;
      if (typeof id != "undefined" && id != "") {
        this.licenseListParam.columnFilters.id = id;
      } else {
        this.licenseListParam.columnFilters.id = "";
      }
      this.$store
        .dispatch("automation/listTextReply", this.licenseListParam)
        .then(response => {
          this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
          // console.log("licenseOptions", this.licenseOptions);
          if (
            typeof id != "undefined" &&
            id != "" &&
            this.licenseOptions.length > 0
          ) {
            this.selectedLicense = this.licenseOptions;
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingLicense = false;
        });
    },
    // asyncFindLicenseSelect(query) {
    //   // console.log("search")
    //   this.licenseOptions = [];
    //   this.licenseListParam.columnFilters.button_text = query;
    //   this.licenseListParam.columnFilters.id = "";
    //   this.$store
    //     .dispatch("automation/listReplyButtons", this.licenseListParam)
    //     .then(response => {
    //       // this.isLoadingLicense = false;
    //       this.licenseOptions = response.data.data;
    //     }) // sesuai kan dengan method di API
    //     .catch(error => {
    //       // this.isLoadingLicense = false;
    //     });
    // },
    resetDetailButton(buttonType) {
      this.formParam.detail_button = [
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        },
        {
          header_id: this.formParam.detail_button[0].header_id,
          auto_reply_button_id: "",
          button_type: buttonType
        }
      ];
    },
    // asyncFindLicense(query, id) {
    //   this.licenseListParam.columnFilters.button_text = query;
    //   if (typeof id != "undefined" && id != "") {
    //     this.licenseListParam.columnFilters.id = id;
    //   } else {
    //     this.licenseListParam.columnFilters.id = "";
    //   }
    //   this.$store
    //     .dispatch("automation/listReplyButtons", this.licenseListParam)
    //     .then(response => {
    //       this.isLoadingLicense = false;
    //       this.licenseOptions = response.data.data;
    //       // console.log("licenseOptions", this.licenseOptions);
    //       if (
    //         typeof id != "undefined" &&
    //         id != "" &&
    //         this.licenseOptions.length > 0
    //       ) {
    //         this.selectedLicense = this.licenseOptions;
    //       }
    //     }) // sesuai kan dengan method di API
    //     .catch(error => {
    //       this.isLoadingLicense = false;
    //     });
    // },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    clearAllLicense() {
      this.selectedLicense = [];
      this.formParam.header_id = "";
      this.formParam.detail_button = [
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" },
        { header_id: "", auto_reply_button_id: "", button_type: "text_reply" }
      ];
    },

    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },

    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;

          //cek button
          let detailButton = await this.formParam.detail_button;
          // newformParam.detail_button = await [];
          let newParam = {
            header_id: this.formParam.header_id,
            button_type: this.formParam.button_type,
            button_response: this.button_response,
            detail_button: []
          };
          await detailButton.forEach((value, index) => {
            if (value.header_id != "" && value.auto_reply_button_id != "") {
              let newButton = {
                header_id: this.formParam.header_id,
                button_type: this.formParam.button_type,
                auto_reply_button_id: value.auto_reply_button_id
              };
              newParam.detail_button.push(newButton);
            }
          });
          // console.log("newParam",newParam)
          // return;
          await this.$store
            .dispatch("automation/storeCustomRules", newParam)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => { });
              this.searchData();
              if (isExit == 1) {
                let newformParam = {
                  header_id: "",
                  button_type: "text_reply",
                  button_response: '',
                  detail_button: [
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    },
                    {
                      header_id: "",
                      auto_reply_button_id: "",
                      button_type: "text_reply"
                    }
                  ]
                };
                this.$store.dispatch(
                  "automation/actFormParamCustomRules",
                  newformParam
                );
                var elem = this.$refs.dismisModal;
                elem.click();
              } else {
                this.$store.dispatch(
                  "automation/actFormParamCustomRules",
                  this.formParam
                );
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/automation/customRulesText/form.vue